<template>
  <div
    key="home-options"
    v-if="loggedIn"
    class="flex items-center w-full h-full pr-[30px]"
  >
    <PreviousButton @click="goBack" :label="$t('modal.back')" />
    <div class="ml-auto flex items-center gap-2 relative h-8">
      <!-- WAITING CONTENT META INFO -->
      <!-- <BaseAction icon="info" disabled /> -->
      <BaseInputOld
        v-if="hasUserBodyHighlight"
        :value="queryText"
        @input="emit('update-query-text', $event)"
        class="flex items-center rounded-lg border border-primary-contrast text-primary-contrast min-w-10"
        :class="{ 'max-w-13.5': !queryText }"
        placeholder="layout.tooltip.highlight-input-placeholder"
        :path="'highlight'"
        :no-border="true"
        size="xs"
      />
      <div
        class="flex items-center space-x-2 text-xs text-primary-contrast"
        v-if="queryText && hasUserBodyHighlight && !highlightLoading"
      >
        <div v-if="isHighlightsJumpable">
          {{ currentResultIdx + 1 }}/{{ resultLength }}
        </div>
        <div v-else>{{ currentResultIdx }}/{{ resultLength }}</div>

        <BaseAction
          :disabled="!isHighlightsJumpable"
          icon="arrow-up"
          @click="emit('up')"
        />
        <BaseAction
          :disabled="!isHighlightsJumpable"
          icon="arrow-down"
          @click="emit('down')"
        />
        <BaseAction icon="times" @click="emit('clearHighlights')" />
      </div>
      <div
        v-if="hasUserBodyHighlight && highlightLoading"
        class="h-6 w-6 flex items-center justify-center text-xs bg-primary-contrast/10 text-primary-contrast rounded-full"
      >
        <FontAwesomeIcon
          :icon="['fas', 'spinner-third']"
          spin
          class="h-3.5 w-3.5"
        />
      </div>
      <AgentTriggerIcon
        v-if="!highlightLoading && getConfig().displayGeniusTrigger"
        @click="handleOpenGenius"
      />
      <BaseAction
        v-if="displayAiAction && !queryText && !highlightLoading"
        icon="sparkles"
        label="AI"
        type="ai"
        :active="aiCollapseDisplayed"
        @click="emit('toggle-ai-collapse')"
      />
      <BaseTooltip
        v-if="
          diagnosticIsFocused &&
          displayFlowyAction &&
          !queryText &&
          !highlightLoading
        "
        :content="$t('flowy.tooltip')"
        placement="bottom"
      >
        <BaseAction
          icon="project-diagram"
          :active="flowy"
          @click="toggleFlowy"
        />
      </BaseTooltip>

      <BaseTooltip
        v-if="
          !answerModaleIsActive &&
          displayModalAction &&
          !queryText &&
          !highlightLoading
        "
        :content="$t('layout.expand-content')"
        placement="bottom"
      >
        <BaseAction icon="sidebar-flip" :active="modal" @click="forceModal" />
      </BaseTooltip>

      <language-switcher
        v-if="!queryText && !highlightLoading"
        mobile
        centerOptions
        @change="changeLanguage"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAdminStore, useKnowledgeStore } from '@getmayday/vue-modules';
import useEntities from '../../composables/useEntities';
import { useRoute } from 'vue-router';
import PreviousButton from '../Library/PreviousButton.vue';

const adminStore = useAdminStore();
const knowledgeStore = useKnowledgeStore();
const configStore = useConfigStore();
const { goBack, forceModal, changeLanguage, getConfig, openGenius } =
  useEntities();
const route = useRoute();

const { loggedIn, hasUserBodyHighlight } = storeToRefs(adminStore);
const { flowy, modal } = storeToRefs(configStore);
const { diagnosticIsFocused, mainContent } = storeToRefs(knowledgeStore);

const props = defineProps({
  displayFlowyAction: {
    type: Boolean,
    default: true,
  },
  displayAiAction: {
    type: Boolean,
    default: false,
  },
  displayModalAction: {
    type: Boolean,
    default: true,
  },
  aiCollapseDisplayed: {
    type: Boolean,
    default: false,
  },
  queryText: {
    type: String,
    default: '',
  },
  isHighlightsJumpable: {
    type: Boolean,
    default: false,
  },
  highlightLoading: {
    type: Boolean,
    default: false,
  },
  currentResultIdx: {
    type: Number,
    default: 0,
  },
  resultLength: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits([
  'toggle-ai-collapse',
  'update-query-text',
  'up',
  'down',
  'clearHighlights',
]);

const toggleFlowy = () => {
  configStore.setFlowy(!flowy.value);
};

const answerModaleIsActive = computed(
  () => !!route.query.modalAnswerId && route.query.modalAnswerId !== '-1',
);

const handleOpenGenius = () => {
  openGenius('content-view', {
    id: mainContent.value.id,
    key: 'Content',
    label: mainContent.value.label,
  });
};
</script>
